/**
 * REST API client — uses window.FcaEventsConfig for base URL and nonce
 */

function getConfig() {
  return window.FcaEventsConfig || {}
}

function getHeaders(extra = {}) {
  const cfg = getConfig()
  return {
    'Content-Type': 'application/json',
    'X-WP-Nonce': cfg.nonce || '',
    ...extra,
  }
}

function getBase() {
  return (getConfig().apiBase || '/wp-json/fca-events/v1').replace(/\/$/, '')
}

async function request(method, path, body = null, options = {}) {
  const url = getBase() + path
  const init = {
    method,
    headers: getHeaders(options.headers || {}),
    credentials: 'same-origin',
  }
  if (body !== null) {
    if (body instanceof FormData) {
      delete init.headers['Content-Type']
      init.body = body
    } else {
      init.body = JSON.stringify(body)
    }
  }
  const res = await fetch(url, init)
  const data = await res.json().catch(() => ({}))
  if (!res.ok) {
    const err = new Error(data.message || `HTTP ${res.status}`)
    err.data = data
    err.status = res.status
    throw err
  }
  return data
}

export const api = {
  get:    (path, params = {}) => {
    const qs = new URLSearchParams(params).toString()
    return request('GET', path + (qs ? '?' + qs : ''))
  },
  post:   (path, body)        => request('POST',   path, body),
  put:    (path, body)        => request('PUT',    path, body),
  patch:  (path, body)        => request('PATCH',  path, body),
  delete: (path)              => request('DELETE', path),
  upload: (path, formData)    => request('POST',   path, formData),
}

// ── Typed helpers ──────────────────────────────────────────────

export const eventsApi = {
  list:         (params = {}) => api.get('/events', params),
  get:          (slug)        => api.get(`/events/${slug}`),
  create:       (data)        => api.post('/events', data),
  update:       (id, data)    => api.put(`/events/${id}`, data),
  delete:       (id)          => api.delete(`/events/${id}`),
  uploadImage:  (id, form)    => api.upload(`/events/${id}/image`, form),
}

export const bookmarksApi = {
  add:    (id) => api.post(`/events/${id}/bookmark`),
  remove: (id) => api.delete(`/events/${id}/bookmark`),
}

export const categoriesApi = {
  list: () => api.get('/categories'),
}

export const settingsApi = {
  get:  ()     => api.get('/settings'),
  save: (data) => api.post('/settings', data),
}

export const translationsApi = {
  get:  ()     => api.get('/translations'),
  save: (data) => api.post('/translations', data),
}

export const spacesApi = {
  list: () => api.get('/spaces'),
}

export const timezonesApi = {
  list: () => api.get('/timezones'),
}

export const permissionsApi = {
  get: () => api.get('/permissions'),
}
